import { PageBreadcrumbItem } from "components/common/PageBreadcrumb";

// Tipos para Inventário
export type InventarioType = {
  id: number;
  finalizado: boolean;
  validado: boolean;
  data: string;
  produtos?: EstoqueInventarioType[];
};

export type EstoqueInventarioType = {
  id?: number;
  loteId?: number;
  inventarioId?: number;
  produtoId: number;
  produtoCodigo?: number;
  nomeProduto: string;
  fabricante?: string;
  produtoCodigoBarras?: string;
  produtoDescricao?: string;
  numero: string; // lote
  lote?: string; // alias para numero
  rms?: string;
  dataVencimento?: string;
  quantidade: number;
  quantidadeInicial?: number;
  precoUnitario?: number;
  valorTotal?: number;
  createdAt?: string;
  updatedAt?: string;
  // Informações cadastrais para atualizar o produto
  lista?: number;
  classeTerapeutica?: number;
  receituario?: number;
  // Unidade apenas para o lote (não atualiza o produto)
  unidade?: number;
};

// DTOs para mutations
export interface AtualizarLoteDto {
  loteId: number;
  numero: string;
  rms: string;
  novaQuantidade: number;
  // Campos obrigatórios para edição do lote (não atualiza cadastro do produto)
  classeTerapeutica?: number;
  unidade?: number;
}

export interface ExcluirLoteDto {
  loteId: number;
}

export interface CriarInventarioDto {
  data: string; // ISO date string
}

export interface AlterarDataInventarioDto {
  inventarioId: number;
  novaData: string; // ISO date string
}

export interface PesquisarProdutosDto {
  termo?: string;
  pageIndex: number;
  pageSize: number;
}

export interface ProdutoParaInventarioType {
  id: number;
  nome: string;
  codigo: number;
  codigoBarras?: string;
  fabricante?: string;
  ehControlado: boolean;
  estoqueAtual: number;
  unidade?: string;
  jaNoInventario: boolean;
  rms?: string;
  lista?: number;
  classeTerapeutica?: number;
  receituario?: number;
}

export interface LoteInventarioType {
  lote: string;
  quantidade: number;
  rms: string;
}

export interface IncluirProdutoInventarioType {
  produtoId: number;
  lotes: LoteInventarioType[];
  // Informações para atualizar o cadastro se necessário
  lista?: number;
  classeTerapeutica?: number;
  receituario?: number;
  // Unidade apenas para o lote (não atualiza o produto)
  unidade?: number;
}

export interface CriarTransmissaoDto {
  inventarioId: number;
  dataTransmissao: string;
  observacoes?: string;
}

export type TransmissaoType = {
  id: number;
  inventarioId: number;
  dataTransmissao: string;
  observacoes?: string;
  status: 'PENDENTE' | 'ENVIADA' | 'ERRO';
  createdAt: string;
  updatedAt: string;
};

export type CriarMovimentoDto = {
  tipo: 'ENTRADA' | 'VENDA_CONSUMIDOR' | 'PERDA';
  inventarioId: number;
  produtoId: number;
  numero: string; // lote
  rms: string;
  quantidade: number;
  data: string; // Data da operação
  
  // Campos para compra
  numeroNota?: string;
  dataEmissao?: string;
  dataEntrada?: string;
  fornecedorId?: number;
  
  // Campos para venda
  dataReceita?: string;
  medicoId?: number;
  receituario?: string;
  numeroReceita?: string;
  tipoUso?: string;
  classeTerapeutica?: string;
  unidade?: string;
  lista?: string;
  
  // Campos para antimicrobiano
  nomeComprador?: string;
  tipoDocumento?: string;
  numeroDocumento?: string;
  orgaoExpedidor?: string;
  ufExpedidor?: string;
  
  // Campos para controle especial
  nomePaciente?: string;
  idadePaciente?: number;
  unidadeIdade?: string;
  sexo?: string;
  cid?: string;
  usoProlongado?: boolean;

  // Campos para perda
  motivo?: string;
};

export type MovimentoType = {
  id: number;
  tipo: 'ENTRADA' | 'VENDA_CONSUMIDOR' | 'PERDA';
  inventarioId: number;
  produtoId: number;
  produtoDescricao: string;
  produtoCodigo?: number;
  numero: string; // lote
  rms: string;
  quantidade: number;
  data: string;
  
  // Dados do produto
  fabricante?: string;
  codigoBarras?: string;
  
  // Campos para compra
  numeroNota?: string;
  dataEmissao?: string;
  dataEntrada?: string;
  fornecedorId?: number;
  fornecedorNome?: string;
  
  // Campos para venda
  dataReceita?: string;
  medicoId?: number;
  medicoNome?: string;
  receituario?: string;
  numeroReceita?: string;
  tipoUso?: string;
  classeTerapeutica?: string;
  unidade?: string;
  lista?: string;
  
  // Campos para antimicrobiano
  nomeComprador?: string;
  tipoDocumento?: string;
  numeroDocumento?: string;
  orgaoExpedidor?: string;
  ufExpedidor?: string;
  
  // Campos para controle especial
  nomePaciente?: string;
  idadePaciente?: number;
  unidadeIdade?: string;
  sexo?: string;
  cid?: string;
  usoProlongado?: boolean;
  
  // Transmissão
  transmissaoId?: number;
  
  createdAt: string;
  updatedAt: string;
};

export type JanelaTemporalType = {
  dataInicio: string;
  dataFim: string;
  ativa: boolean;
  transmitida: boolean;
};

export type EstatisticasMovimentosType = {
  totalEntradas: number;
  totalVendas: number;
  totalPerdas: number;
  valorTotalEntradas?: number;
  valorTotalVendas?: number;
};

// Breadcrumbs para SNGPC
export const sngpcBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "SNGPC",
    url: "#!",
  },
];

export const inventarioBreadcrumbItems: PageBreadcrumbItem[] = [
  ...sngpcBreadcrumbItems,
  {
    label: "Inventário",
    active: true,
  },
];

export const transmissoesBreadcrumbItems: PageBreadcrumbItem[] = [
  ...sngpcBreadcrumbItems,
  {
    label: "Transmissões",
    active: true,
  },
];

export const movimentacaoBreadcrumbItems: PageBreadcrumbItem[] = [
  ...sngpcBreadcrumbItems,
  {
    label: "Movimentação",
    active: true,
  },
];

export const relatoriosBreadcrumbItems: PageBreadcrumbItem[] = [
  ...sngpcBreadcrumbItems,
  {
    label: "Relatórios",
    active: true,
  },
];


// Status da transmissão para badges
export const getTransmissaoStatusBadge = (status: TransmissaoType['status']) => {
  switch (status) {
    case 'ENVIADA':
      return { variant: "success" as const, text: "Enviada" };
    case 'ERRO':
      return { variant: "danger" as const, text: "Erro" };
    default:
      return { variant: "warning" as const, text: "Pendente" };
  }
};

// Tipos de movimento para badges
export const getMovimentoTipoBadge = (tipo: MovimentoType['tipo']) => {
  switch (tipo) {
    case 'ENTRADA':
      return { variant: "success" as const, text: "Entrada", icon: "faShoppingCart" };
    case 'VENDA_CONSUMIDOR':
      return { variant: "info" as const, text: "Venda", icon: "faReceipt" };
    case 'PERDA':
      return { variant: "danger" as const, text: "Perda", icon: "faExclamationTriangle" };
    default:
      return { variant: "secondary" as const, text: tipo, icon: "faQuestion" };
  }
}; 